import { WinsWall } from "@/components/WinsWall";

export default function CoachWins() {
  return (
    <div className="space-y-10" data-testid="coach-wins">
      <header>
        <div className="overline">Celebration</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-6 leading-tight">
          Wall of <span className="font-script normal-case" style={{ fontSize: "1.15em", color: "var(--accent)", letterSpacing: 0 }}>wins</span>
        </h1>
        <p className="text-secondary-luxe text-sm mt-4 max-w-2xl">
          Every win your clients post. Star the best ones to pin them to the top — delete anything off-brand.
        </p>
        <div className="bronze-rule mt-6" />
      </header>
      <WinsWall isCoach />
    </div>
  );
}
